import { z } from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

export const problematicBookingFilterSchema = z.object({
	search: optionalFilterString,
	status: optionalFilterString,
});
